import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import formatCurrency from "../../utils/formatCurrency";

export default function TotalRow({ cycle, collection }) {
  let total = collection.reduce(
    (sum, item) => sum + parseFloat(item.attributes.deduction),
    0
  );

  let formatTotal = formatCurrency(total, cycle.attributes.currency);

  return (
    <>
      <div className="text-right">
        <a className="btn btn-green not-visible">Download</a>
        <span className="pl10 pr10">Total</span>
        <span className="amount pr16">{formatTotal}</span>
      </div>
    </>
  );
}
